import { render, staticRenderFns } from "./SimpleDataTable.vue?vue&type=template&id=62687025&scoped=true"
import script from "./SimpleDataTable.vue?vue&type=script&lang=js"
export * from "./SimpleDataTable.vue?vue&type=script&lang=js"
import style0 from "./SimpleDataTable.vue?vue&type=style&index=0&id=62687025&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62687025",
  null
  
)

export default component.exports